// src/components/dashboard/DashboardShell.js
// Generic page frame shared by every role's dashboard: a title/subtitle
// header plus whatever grid of widgets the page composes as children.
import React from 'react';

function DashboardShell({ title, subtitle, actions, children }) {
  return (
    <div className="dashboard-shell">
      <div className="d-flex justify-content-between align-items-start flex-wrap mb-4">
        <div>
          <h1 className="h3 mb-1">{title}</h1>
          {subtitle && <p className="text-muted mb-0">{subtitle}</p>}
        </div>
        {actions && <div className="mt-2 mt-md-0">{actions}</div>}
      </div>
      {children}
    </div>
  );
}

export default DashboardShell;
